import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  EventEmitter,
  HostListener,
  inject,
  Input,
  OnChanges,
  Output,
  Renderer2,
  signal,
  ViewChild,
  WritableSignal,
} from '@angular/core';
import { NgClass } from '@angular/common';
import { ActivoDigital } from '@interfaces/products/activo_digital_interface';
import { DeviceScreenFamilyService } from '@core/services/device-screen-family/device-screen-family.service';

@Component({
  selector: 'ln-product-info-thumbnails',
  imports: [NgClass],
  templateUrl: './ln-product-info-thumbnails.component.html',
  styleUrl: './ln-product-info-thumbnails.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LnProductInfoThumbnailsComponent implements AfterViewInit, OnChanges {
  readonly TAG = 'LnProductInfoThumbnailsComponent';
  @Input({ required: true }) activosDigitales!: ActivoDigital[];
  @ViewChild('thumbNailsContainer', { static: false })
  scrollList!: ElementRef<HTMLUListElement>;
  @Input() selectedImage = 0;
  @Output() selectedImageChange = new EventEmitter<number>();
  showMoreElement = computed<boolean>(() => this.scrollInCero() && this.activosDigitalesLenght() > this.colCount);
  scrollInCero = signal(true);
  horizontalMode = signal(true);
  protected readonly colCount: number = 6;
  private renderer = inject(Renderer2);
  protected activosDigitalesLenght: WritableSignal<number> = signal(0);
  private deviceScreenFamily = inject(DeviceScreenFamilyService);
  protected currentScreenSize = this.deviceScreenFamily.currentDeviceScreenFamily;
  @HostListener('window:resize', ['$event'])
  onScreenResize() {
    this.setHorizontalMode();
  }

  ngAfterViewInit() {
    this.ScrollListen();
    this.setHorizontalMode();
  }

  ngOnChanges(): void {
    this.activosDigitalesLenght.set(this.activosDigitales.length);
  }
  ScrollListen() {
    this.renderer.listen(this.scrollList.nativeElement, 'scroll', () => {
      this.scrollInCero.set(
        this.scrollList.nativeElement.scrollLeft == 0 && this.scrollList.nativeElement.scrollTop == 0
      );
    });
  }

  private setHorizontalMode() {
    this.horizontalMode.set(window.innerWidth <= 640);
  }
  SelectImage(imageName: string) {
    const found = this.activosDigitales.findIndex(activo => activo.urlImg === imageName);
    if (found != undefined) {
      this.selectedImage = found;
      this.selectedImageChange.emit(found);
    }
  }
}
